import { defineStore } from 'pinia'
import { EaseChatSDK, EaseChatClient } from '@/IM/initwebsdk'
import { message } from 'ant-design-vue'
import { useImConversationStore, useImInfoStore  } from '@/store'
import dayjs from 'dayjs'
import tool from '@/utils/tool'
import router from '@/router'
import imuserApi from '@/api/onlineChat/imuserApi'
/**
 * 环信IM消息
 */
export const useImMessageStore = defineStore({
    id: 'imMessage',
    state: () => ({
        // 当前正在聊天对象
        currentChat: {
            lastMessage: {}
        },
        // 当前正在聊天对象的历史消息列表
        messageList: [],
    }),
    actions: {
        // 获取历史消息列表
        getMessageList(cursor = '-1') {
            return new Promise((resolve) => {
                const options = {
                    cursor,
                    targetId: this.currentChat.conversationId,
                    pageSize: 10,
                    chatType: 'singleChat',
                    searchDirection: 'up',
                    searchOptions: {
                        startTime: dayjs().subtract(30, 'day').valueOf(),
                        endTime: dayjs().endOf('day').valueOf(), 
                    },
                }
                EaseChatClient.getHistoryMessages(options).then((res) => {
                    this.messageList = [...this.messageList, ...res.messages]
                    resolve(res)
                }).catch((e) => {
                    message.error(`获取历史消息失败：[${e.type}]${e.message}`)
                })
            })
        },
        // 更新当前正在聊天对象
        updateCurrentChat(data) {
            this.currentChat = data
        },
        // 收到消息，更新历史消息列表
        updateMessageList(msgObj) {
            this.messageList.unshift(msgObj)
        },
        // 清空历史消息列表
        clearMessageList() {
            this.messageList = []
        },
        // 企业向个人主动发起聊天
        sendPersonMessage(userId) {
            return new Promise(async (resolve) => {
                const res =  await imuserApi.imByCompany({ userId })
                await this.sendTxtMessage('你好，看了你的简历，方便聊聊吗？', res.id)
                tool.session.set('conversationId', res.id)
                router.push({ path: '/onlineChat' })
                resolve()
            })
        },
        // 发送文本消息
        sendTxtMessage(msg, to) {
            return new Promise((resolve) => {
                const msgBody = EaseChatSDK.message.create({
                    type: "txt", // 消息类型。
                    chatType: "singleChat", // 会话类型
                    msg, // 发送内容
                    to, // 消息接收方：单聊为对方用户 ID，群聊和聊天室分别为群组 ID 和聊天室 ID。
                })
                EaseChatClient.send(msgBody).then(({ serverMsgId })=>{
                    msgBody.id = serverMsgId
                    msgBody.from = EaseChatClient.user
                    this.updateMessageList(msgBody)
                    // 更新会话列表
                    setTimeout(() => useImConversationStore().getConversationList(), 500)
                    resolve()
                }).catch((e)=>{
                    message.error(`发送失败请重试：[${e.type}]${e.message}`)
                    useImInfoStore().getImInfo()
                })
            })
        },
        // 发送图片消息
        sendImgMessage(to, file, width, height) {
            return new Promise((resolve) => {
                const option = {
                    file,
                    to,
                    width,
                    height,
                    type: "img",
                    chatType: "singleChat",
                    ext: {},
                    // 图片文件上传失败
                    onFileUploadError: function () {},
                    // 图片文件上传进度。
                    onFileUploadProgress: function () {},
                    // 图片文件上传成功。
                    onFileUploadComplete: function () {},
                }
                const msgBody = EaseChatSDK.message.create(option)
                EaseChatClient.send(msgBody).then(({ serverMsgId }) => {
                    msgBody.id = serverMsgId
                    msgBody.from = EaseChatClient.user
                    this.updateMessageList(msgBody)
                    // 更新会话列表
                    setTimeout(() => useImConversationStore().getConversationList(), 500)
                    resolve()
                }).catch((e) => {
                    message.error(`发送失败请重试：[${e.type}]${e.message}`)
                    useImInfoStore().getImInfo()
                })
            })
        },
        // 自定义发送职位消息
        sendJobMessage(to, customExts = {}, ext = {}) {
            return new Promise((resolve) => {
                const option = {
                    type: "custom", // 消息类型。
                    chatType: "singleChat", // 会话类型
                    customEvent: '', // 自定义事件。
                    customExts, // 通过键值对设置自定义消息内容。
                    ext, // 消息扩展字段，不能设置为空，即设置为 "ext:null" 这种形式会出错。
                    to, // 消息接收方：单聊为对方用户 ID，群聊和聊天室分别为群组 ID 和聊天室 ID。
                }
                // 创建一条自定义消息。
                const msgBody = EaseChatSDK.message.create(option)
                EaseChatClient.send(msgBody).then(() => {
                    // 更新会话列表
                    setTimeout(() => useImConversationStore().getConversationList(), 500)
                    resolve()
                }).catch((e) => {
                    message.error(`发送失败请重试：[${e.type}]${e.message}`)
                    useImInfoStore().getImInfo()
                })
            })
        },
        // 发送自定义消息
        sendCustomMessage(to, customExts = {}, ext = {}) {
            return new Promise((resolve) => {
                const option = {
                    type: "custom", // 消息类型。
                    chatType: "singleChat", // 会话类型
                    customEvent: '', // 自定义事件。
                    customExts, // 通过键值对设置自定义消息内容。
                    ext, // 消息扩展字段，不能设置为空，即设置为 "ext:null" 这种形式会出错。
                    to, // 消息接收方：单聊为对方用户 ID，群聊和聊天室分别为群组 ID 和聊天室 ID。
                }
                const msgBody = EaseChatSDK.message.create(option)
                EaseChatClient.send(msgBody).then(({ serverMsgId }) => {
                    msgBody.id = serverMsgId
                    msgBody.from = EaseChatClient.user
                    this.updateMessageList(msgBody)
                    // 更新会话列表
                    setTimeout(() => useImConversationStore().getConversationList(), 500)
                    resolve()
                }).catch((e) => {
                    message.error(`发送失败请重试：[${e.type}]${e.message}`)
                    useImInfoStore().getImInfo()
                })
            })
        },
    }
})